import React, { useCallback } from 'react';
import { Pagination, NoDataCard } from '@nile/components';
import {
  BadgeCell,
  TextCell,
  AssetAgeCell,
  SurveyTypeCell,
  CommentCell
} from '@nile/reports/src/modules/component';
import envConfig from '@nile/home/src/Config/env';
import { isEmpty } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { Wrapper, Tr } from './style';

const columnGroups = {
  PLAIN: TextCell,
  BGCOLOR: BadgeCell,
  AssetAge: AssetAgeCell,
  SurveyType: SurveyTypeCell,
  Comments: CommentCell
};

function GroupedDataTable(props) {
  const {
    columns = [],
    data = {},
    listInfo = {},
    refreshTable,
    isLoading = false,
    pagination = false
  } = props;

  const { data: recordData = [] } = data;

  const navigatePages = useCallback((pageNumber) => {
    refreshTable(
      {},
      {
        pageSize: listInfo?.pageSize || 100,
        page: pageNumber || 0
      }
    );
  }, []);

  const getAdditionalMeta = () => {
    const addsMeta =
      data?.additionalData &&
      Object.entries(data?.additionalData).map(([key, value]) => ({
        [key.split('.').join('')]: value
      }))?.[0];
    return addsMeta || {};
  };

  const addMeta = getAdditionalMeta();

  return (
    <>
      <Wrapper className="fx fw" fullHeight={!pagination}>
        <table>
          <thead>
            <tr>
              {columns.map((el) => (
                <th>{el.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {isEmpty(data) || isEmpty(recordData) ? (
              <tr className="emptyRow">
                <td colSpan={columns.length || 1}>
                  <NoDataCard
                    imageURL={`url(${`${envConfig.imageRoot}svg/not-found.svg`})`}
                    text={
                      <FormattedMessage id="app.selectionsheet.emptyState" />
                    }
                  />
                </td>
              </tr>
            ) : (
              recordData.map((rcd) => (
                <TableRow
                  data={rcd}
                  columns={columns}
                  isLoading={isLoading}
                  meta={addMeta}
                  name={null}
                />
              ))
            )}
          </tbody>
        </table>
      </Wrapper>
      {pagination && (
        <Pagination
          onPageChange={navigatePages}
          rowCount={listInfo?.pageSize || 100}
          recordCount={listInfo?.totalCount}
          pages={Math.ceil(listInfo.totalCount / listInfo.pageSize) || 0}
          page={listInfo.page || 0}
        />
      )}
    </>
  );
}

const TableRow = (props) => {
  const { data, columns, isLoading, meta, name = null } = props;

  const concatedName =
    name && data?.value
      ? name.concat(`  ⇨  ${data?.value} `)
      : name ?? data.value;
  if (data?.type === 'groups') {
    return (
      <>
        {data.hasOwnProperty('groups') &&
          data?.groups.map((subrow) => (
            <TableRow
              data={subrow}
              columns={columns}
              isLoading={isLoading}
              meta={meta}
              name={concatedName}
            />
          ))}
      </>
    );
  }

  if (data?.type === 'records') {
    return (
      <>
        <Tr className="grpHeaderRow">
          <th colSpan={columns.length || 1} className="grpHeader">
            {concatedName}
          </th>
        </Tr>
        {data?.records?.map((cellData) => (
          <tr className={isLoading ? 'loading' : ''}>
            {cellData.map((el, idx) => (
              <>
                <td>
                  {columnGroups[columns[idx].dataReportRenderType]({
                    data: el,
                    field: columns[idx],
                    meta: meta
                  })}
                </td>
              </>
            ))}
          </tr>
        ))}
      </>
    );
  }
  return <></>;
};

export default GroupedDataTable;
